module.exports = __webpack_public_path__ + "r-v3/img/info_warning.80f384d9.svg";